import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface PropsModalYesNo {
  title: string;
  message: string;
  show: boolean;
  onYes: () => void;
  onNo: () => void;
}

const ModalYesNo = ({
  title,
  message,
  show,
  onYes,
  onNo,
}: PropsModalYesNo): JSX.Element => {
  return (
    <Modal show={show} onHide={onNo} centered>
      <Modal.Body>
        <div className="d-flex flex-column">
          <p className="fw-bold" style={{ fontWeight: '600' }}>
            {title}
          </p>
          <p style={{ color: '#828282' }}>{message}</p>
          <div className="d-flex justify-content-end">
            <Button className="button-popup-secundary" onClick={onNo}>
              Não
            </Button>
            <Button className="button-popup-primary" onClick={onYes}>
              Sim
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalYesNo;
